import { NgModule, APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { AppConfig } from './consola/app.config';
import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { CarouselModule } from 'primeng/carousel';
import { ChartModule } from 'primeng/chart';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipsModule } from 'primeng/chips';
import { CodeHighlighterModule } from 'primeng/codehighlighter';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ColorPickerModule } from 'primeng/colorpicker';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DataViewModule } from 'primeng/dataview';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { FieldsetModule } from 'primeng/fieldset';
import { FileUploadModule } from 'primeng/fileupload';
import { FullCalendarModule } from 'primeng/fullcalendar';
import { GalleriaModule } from 'primeng/galleria';
import { InplaceModule } from 'primeng/inplace';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputMaskModule } from 'primeng/inputmask';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { LightboxModule } from 'primeng/lightbox';
import { ListboxModule } from 'primeng/listbox';
import { MegaMenuModule } from 'primeng/megamenu';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { MultiSelectModule } from 'primeng/multiselect';
import { OrderListModule } from 'primeng/orderlist';
import { OrganizationChartModule } from 'primeng/organizationchart';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PaginatorModule } from 'primeng/paginator';
import { PanelModule } from 'primeng/panel';
import { PanelMenuModule } from 'primeng/panelmenu';
import { PasswordModule } from 'primeng/password';
import { PickListModule } from 'primeng/picklist';
import { ProgressBarModule } from 'primeng/progressbar';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RatingModule } from 'primeng/rating';
import { RippleModule } from 'primeng/ripple';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SidebarModule } from 'primeng/sidebar';
import { SlideMenuModule } from 'primeng/slidemenu';
import { SliderModule } from 'primeng/slider';
import { SplitButtonModule } from 'primeng/splitbutton';
import { StepsModule } from 'primeng/steps';
import { TabMenuModule } from 'primeng/tabmenu';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { TerminalModule } from 'primeng/terminal';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { ToastModule } from 'primeng/toast';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ToolbarModule } from 'primeng/toolbar';
import { TooltipModule } from 'primeng/tooltip';
import { TreeModule } from 'primeng/tree';
import { TreeTableModule } from 'primeng/treetable';
import { VirtualScrollerModule } from 'primeng/virtualscroller';

import { AppCodeModule } from './consola/app.code.component';
import { AppComponent } from './app.component';
import { AppMainComponent } from './app.main.component';
import { AppConfigComponent } from './consola/app.config.component';
import { AppMenuComponent } from './consola/menu/app.menu.component';
import { AppMenuitemComponent } from './consola/menu/app.menuitem.component';
import { AppBreadcrumbComponent } from './consola/app.breadcrumb.component';
import { AppTopBarComponent } from './consola/app.topbar.component';
import { AppFooterComponent } from './consola/app.footer.component';
import { AppNotfoundComponent } from './consola/notfound/app.notfound.component';
import { AppLoginComponent } from './consola/login/app.login.component';
import { AppVerificarCambioComponent } from './consola/verificar-cambio/app.verificar-cambio.component';
import { AppVerificarActivacionComponent } from './consola/verificar-activacion/app.verificar-activacion.component';
import { AppBreadcrumbService } from './consola/app.breadcrumb.service';
import { MenuService } from './consola/menu/app.menu.service';
import { AppRoutes } from './app.routes';
import { CoreModule } from './core/core.module';
import { MessageService, ConfirmationService } from 'primeng/api';
import { SessionService } from './core/_services/session.service';
import { StoreDevtoolsModule } from "@ngrx/store-devtools"
import { StoreModule } from '@ngrx/store';
import { environment } from '../environments/environment';
import { reducerCliente } from './reducer/app.reducer.cliente';
import { reducerLista } from './reducer/app.reducer.listas';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { RecuperarContrasenaComponent } from './consola/recuperar-contrasena/recuperar-contrasena.component';
import { InicioComponent } from './consola/inicio/inicio.component';
import { CambioContrasenaComponent } from './consola/cambio-contrasena/cambio-contrasena.component';
import { RegistroComponent } from './consola/registro/registro.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { WebcamModule } from 'ngx-webcam';
import { EvaluacionesComponent } from './evaluaciones/evaluaciones.component';
import { EvaluacionCompetenciasComponent } from './evaluacion-competencias/evaluacion-competencias.component';
import { SafeResourceUrl } from './consola/app.safeResourceUrl.pipe';
import { RecepcionTkComponent } from './consola/recepcion-tk/recepcion-tk.component';
import { FichaComponent } from './ficha/ficha.component';
import { ConsultasComponent } from './consultas/consultas.component';
import { EjecutarConsultaComponent } from './ejecutar-consulta/ejecutar-consulta.component';
import { FiltroCandidatosComponent } from './filtro-candidatos/filtro-candidatos.component';
import { HeadHunterComponent } from './head-hunter/head-hunter.component';
import { HojaVidaCandidatoComponent } from './hoja-vida-candidato/hoja-vida-candidato.component';
import { CrearRequerimientoCargoClienteComponent } from './crear-requerimiento-cargo-cliente/crear-requerimiento-cargo-cliente.component';
import { ReqHeadHunterComponent } from './req-head-hunter/req-head-hunter.component';
import { FichasComponent } from './fichas/fichas.component';
import { DiasServicioComponent } from './dias-servicio/dias-servicio.component';
import { PersonaAsignadaComponent } from './persona-asignada/persona-asignada.component';
import { DisponibilidadComponent } from './disponibilidad/disponibilidad.component';
import { AnsComponent } from './ans/ans.component';
import { ProcesosComponent } from './procesos/procesos.component';
import { IdiomasComponent } from './idiomas/idiomas.component';
import { ActividadAdicionalComponent } from './actividad-adicional/actividad-adicional.component';
import { AsociacionFichaComponent } from './asociacion-ficha/asociacion-ficha.component';
import { VolumenDatosComponent } from './volumen-datos/volumen-datos.component';
import { ConsultasEjecutarComponent } from './consultas-ejecutar/consultas-ejecutar.component';
import { EstadoProcesoComponent } from './estado-proceso/estado-proceso.component';
import { ProcesosContratacionComponent } from './procesos-contratacion/procesos-contratacion.component';
import { SolicitudesBackendComponent } from './solicitudes-backend/solicitudes-backend.component';

@NgModule({
    imports: [
        AppRoutes,
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        BrowserAnimationsModule,
        AccordionModule,
        AutoCompleteModule,
        BreadcrumbModule,
        ButtonModule,
        CalendarModule,
        CardModule,
        CarouselModule,
        ChartModule,
        CheckboxModule,
        ChipsModule,
        CodeHighlighterModule,
        ConfirmDialogModule,
        ColorPickerModule,
        ContextMenuModule,
        CoreModule.forRoot(),
        NgIdleKeepaliveModule.forRoot(),
        DataViewModule,
        DialogModule,
        DropdownModule,
        FieldsetModule,
        FileUploadModule,
        FullCalendarModule,
        GalleriaModule,
        InplaceModule,
        InputNumberModule,
        InputMaskModule,
        InputSwitchModule,
        InputTextModule,
        InputTextareaModule,
        LightboxModule,
        ListboxModule,
        MegaMenuModule,
        MenuModule,
        MenubarModule,
        MessageModule,
        MessagesModule,
        MultiSelectModule,
        OrderListModule,
        OrganizationChartModule,
        OverlayPanelModule,
        PaginatorModule,
        PanelModule,
        PanelMenuModule,
        PasswordModule,
        PickListModule,
        ProgressBarModule,
        RadioButtonModule,
        RatingModule,
        RippleModule,
        ScrollPanelModule,
        SelectButtonModule,
        SidebarModule,
        SlideMenuModule,
        SliderModule,
        SplitButtonModule,
        StepsModule,
        TableModule,
        TabMenuModule,
        TabViewModule,
        TerminalModule,
        TieredMenuModule,
        ToastModule,
        ToggleButtonModule,
        ToolbarModule,
        TooltipModule,
        TreeModule,
        TreeTableModule,
        VirtualScrollerModule,
        AppCodeModule,
        NgxSpinnerModule,
        WebcamModule,
        StoreModule.forRoot({
            registroCliente: reducerCliente,
            listas: reducerLista
        }),
        StoreDevtoolsModule.instrument({
            maxAge: 4,
            logOnly: environment.production
        }),
        NgbModule
    ],
    declarations: [
        AppComponent,
        AppMainComponent,
        AppMenuComponent,
        AppMenuitemComponent,
        AppConfigComponent,
        AppBreadcrumbComponent,
        AppTopBarComponent,
        AppFooterComponent,
        AppLoginComponent,
        AppVerificarCambioComponent,
        AppVerificarActivacionComponent,
        AppNotfoundComponent,
        InicioComponent,
        CambioContrasenaComponent,
        RegistroComponent,
        RecuperarContrasenaComponent,
        EvaluacionesComponent,
        EvaluacionCompetenciasComponent,
        SafeResourceUrl,
        RecepcionTkComponent,
        FichaComponent,
        ConsultasComponent,
        EjecutarConsultaComponent,
        FiltroCandidatosComponent,
        HeadHunterComponent,
        HojaVidaCandidatoComponent,
        CrearRequerimientoCargoClienteComponent,
        ReqHeadHunterComponent,
        FichasComponent,
        DiasServicioComponent,
        PersonaAsignadaComponent,
        DisponibilidadComponent,
        AnsComponent,
        ProcesosComponent,
        IdiomasComponent,
        ActividadAdicionalComponent,
        AsociacionFichaComponent,
        VolumenDatosComponent,
        ConsultasEjecutarComponent,
        EstadoProcesoComponent,
        ProcesosContratacionComponent,
        SolicitudesBackendComponent,
    ],
    providers: [
        AppConfig,
        {
            provide: APP_INITIALIZER,
            useFactory: initializeApp,
            deps: [AppConfig],
            multi: true
        },
        { provide: LocationStrategy, useClass: HashLocationStrategy }, MenuService, AppBreadcrumbService,
        MessageService, SessionService, ConfirmationService
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }

export function initializeApp(appConfig: AppConfig) {
    return () => appConfig.load();
}
